export default __webpack_public_path__ + "static/media/close.449df64c.svg";